import { ReactNode } from 'react';

import { Box, Container, Flex } from '@mantine/core';

import { BookContextProvider } from '@/contexts/BookContext/BookContextProvider';

import { Header } from '@/widgets/Header';

import useInstallPWA from '@/shared/hooks/useInstallPWA.tsx';

import classes from './DesktopLayout.module.css';

type DesktopProps = {
	leftSlot?: ReactNode;
	rightSlot: ReactNode;
};

export const DesktopLayout = ({ leftSlot, rightSlot }: DesktopProps) => {
	const installPwa = useInstallPWA();

	return (
		<BookContextProvider>
			<Header />
			<Container fluid h={'calc(100vh - 68px)'} bg="#F0F1F3" px={38} py={24}>
				<Flex w={'100%'} gap={8}>
					{leftSlot && (
						<Box className={classes.leftSlot}>
							<Flex direction="column" gap="xs">
								{leftSlot}
								{installPwa}
							</Flex>
						</Box>
					)}
					<Flex direction="column" className={classes.rightSlot}>
						{rightSlot}
					</Flex>
				</Flex>
			</Container>
		</BookContextProvider>
	);
};
